module.exports = __webpack_public_path__ + "static/img/jigou-jiangsu-top.0f18dd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-jiangsu-top.png
// module id = gVp8
// module chunks = 2